module.exports = __webpack_public_path__ + "static/img/banner5.a356e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/banner5.png
// module id = 34Js
// module chunks = 1